
import formInfoSectionWlp from './formInfoSectionWlp';
import formExternalLinksWLP from './formExternalLinksWLP';
import formFAQWLP from './formFAQWLP';

export default {
  title: 'Info Sections and Links White label Pro',
  attributeName: 'infoSectionsPro',
  getURL: 'mainHubId/configId/infoSectionsPro',
  createURL: 'mainHubId/configId/infoSectionsPro',
  updateURL: 'mainHubId/configId/infoSectionsPro',
  removeURL: 'mainHubId/configId/infoSectionsPro',
  sessionParams: ['mainHubId','configId'],
  idUpdate:false,
  noArea: false,
  isMainHub: true,
  autoUpdate: true,
  formConfig: [
    formInfoSectionWlp,
    formExternalLinksWLP,
    // formFAQWLP,
  ],
  autoUpdate: false,
};
